import {Component} from '@angular/core';
import {ModalController, NavParams} from '@ionic/angular';

/**
 * Generated class for the GenericModalComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'emc-modal',
    templateUrl: 'contract-modal.html',
    styleUrls: ['contract-modal.scss']
})
export class ContractModalComponent {

    modalTitle: string;

    constructor(public viewCtrl: ModalController, params: NavParams) {
        this.modalTitle = 'Contrato';
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }


}
